<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Connectors: {{ config?.name }}</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/organisations']">Organisations</a>
          </li>
          <li class="breadcrumb-item active">Connectors</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">
      <mat-tab-group
        [selectedIndex]="selected"
        (selectedIndexChange)="selected = $event"
        *ngIf="!loading"
        #tabGroup
      >
        <mat-tab *ngFor="let type of connectorTypeLabels" label="type">
          <ng-template mat-tab-label>
            <span [class.mat-error]="">{{ type }}</span>
          </ng-template>
          <app-connector-form
            [orgTag]="orgTag"
            [type]="type"
            [connectors]="connectors"
            [configuredConnectors]="configuredConnectors"
            (reload)="handleReload($event)"
          ></app-connector-form>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</section>
